module.exports = __webpack_public_path__ + "img/default_image_modal.59b588af.png";